function directive($parse) {
    return function (scope, element, attrs) {
        var fn = $parse(attrs.ngRightClick);
        element.bind('contextmenu', function (event) {
            scope.$apply(function () {
                event.preventDefault();
                fn(scope, {$event:event});
            });
        });
    };
}

directive.$inject = ['$parse'];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/rightclick/rightclick.js
 **/